document.querySelectorAll(".custom-select__option").forEach((el) => {
  const swatchColor = el.getAttribute("data-swatch");
  el.style.setProperty("--swatch-color", swatchColor);
});
document.querySelectorAll(".custom-select__listbox").forEach((li) => {
  li.addEventListener("click", function () {
    let color = event.target.dataset.color;
    setTimeout(() => {
      document.querySelectorAll(".custom-select__btn").forEach((ele) => {
        const swatchColor = ele.getAttribute("data-swatch");
        ele.style.setProperty("--swatch-color", swatchColor);
      });
    }, 150);
  });
});
// --- 1) Utility: watch for dynamically-inserted buttons and attach a click handler once ---
function waitForElements(selectors, onFound) {
  const seen = new WeakSet();
  const scan = () => {
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        if (!seen.has(el)) {
          seen.add(el);
          onFound(el, sel);
        }
      });
    });
  };
  // initial + observe
  scan();
  new MutationObserver(scan).observe(document.body, {
    childList: true,
    subtree: true,
  });
}
// --- 2) Cart reader + bundle analyzer ---
async function getCart() {
  const res = await fetch("/cart.js", { credentials: "same-origin" });
  if (!res.ok) throw new Error(`Cart fetch failed: ${res.status}`);
  return res.json();
}
/**
 * Analyze cart for items whose product handle matches a pattern (default: /bundle/i)
 * Returns:
 * {
 *   totalBundleQty: number,            // sum of quantities of all bundle items
 *   distinctBundleCount: number,       // number of distinct bundle product handles
 *   perHandleQty: { [handle]: number}, // quantity per bundle handle
 *   lines: array                       // raw matching line items
 * }
 */
async function analyzeBundles({ pattern = /bundle/i } = {}) {
  const cart = await getCart();
  // NOTE: Shopify /cart.js line items include `handle` (product handle) and `quantity`.
  const bundleLines = cart.items.filter((item) => pattern.test(item.handle));
  const perHandleQty = bundleLines.reduce((acc, item) => {
    acc[item.handle] = (acc[item.handle] || 0) + item.quantity;
    return acc;
  }, {});
  const totalBundleQty = bundleLines.reduce(
    (sum, item) => sum + item.quantity,
    0
  );
  const distinctBundleCount = Object.keys(perHandleQty).length;
  return {
    totalBundleQty,
    distinctBundleCount,
    perHandleQty,
    lines: bundleLines,
  };
}
// --- 3) Wire it to your two button targets ---
const btnSelectors = [
  "form.rb-form .rb-btn-wrapper button.rb-btn",
  ".status-bar-sign-up .rb-form .rb-btn",
];
// waitForElements(btnSelectors, (btn, selector) => {
//   btn.addEventListener(
//     "click",
//     async (e) => {
//       try {
//         // If you need to wait for Shopify to add to cart first, you can delay slightly:
//         // await new Promise(r => setTimeout(r, 200));
//         const { totalBundleQty, distinctBundleCount, perHandleQty } =
//           await analyzeBundles({
//             // Customize the match rule here if needed:
//             pattern: /bundle/i,
//           });

//         // Use the results however you like:
//         console.log("[Bundle Analysis]", {
//           clickedSelector: selector,
//           totalBundleQty,
//           distinctBundleCount,
//           perHandleQty,
//         });
//         // Example: fire a custom event your other scripts can listen for
//         const evt = new CustomEvent("bundleCartAnalysis", {
//           detail: { totalBundleQty, distinctBundleCount, perHandleQty },
//         });
//         setTimeout(() => {
//           window.dispatchEvent(evt);
//         }, 2000);

//         // Example: update some DOM node if you have one
//         // document.querySelector('[data-bundle-qty]').textContent = totalBundleQty;
//       } catch (err) {
//         console.error("Bundle check failed:", err);
//       }
//     },
//     { passive: true }
//   );
// });

// Wait for .shopify-app-block .jdgm-all-reviews-rating-wrapper to exist
// function waitForElement_(selector, callback) {
//   const el = document.querySelector(selector);
//   if (el) return callback(el);

//   const observer = new MutationObserver(() => {
//     const target = document.querySelector(selector);
//     if (target) {
//       observer.disconnect();
//       callback(target);
//     }
//   });

//   observer.observe(document.body, { childList: true, subtree: true });
// }

// waitForElement_('.shopify-app-block .jdgm-all-reviews-rating-wrapper .jdgm-carousel-item', (el) => {
//   el.addEventListener('click', () => {
//     window.location.href = '/pages/reviews';
//   });
// });


// waitForElement_('.shopify-app-block .jdgm-carousel__item-container .jdgm-carousel-item', (el) => {
//   el.style.cursor = 'pointer'; // show clickable cursor
//   el.addEventListener('click', () => {
//     window.location.href = '/pages/reviews';
//   });
// });


// (function () {
//   const REVIEW_PAGE_URL = '/pages/reviews';

//   document.addEventListener('click', function (e) {
//     if (
//       e.target.closest('.jdgm-carousel__left-arrow') ||
//       e.target.closest('.jdgm-carousel__right-arrow') ||
//       e.target.closest('.jdgm-carousel__arrows') ||
//       e.target.closest('.jdgm-carousel-dot') ||
//       e.target.closest('.jdgm-carousel__dot') ||
//       e.target.closest('button') ||
//       e.target.closest('a')
//     ) {
//       return;
//     }

//     const reviewItem = e.target.closest('.shopify-app-block .jdgm-carousel-item');
//     const ratingWrapper = e.target.closest('.shopify-app-block .jdgm-all-reviews-rating-wrapper');

//     if (reviewItem || ratingWrapper) {
//       window.location.href = REVIEW_PAGE_URL;
//     }
//   });

  // const style = document.createElement('style');
  // style.innerHTML = `
  //   .shopify-app-block .jdgm-carousel-item,
  //   .shopify-app-block .jdgm-all-reviews-rating-wrapper {
  //     cursor: pointer;
  //   }
  // `;
  // document.head.appendChild(style);
//})();



window.jdgmReviewLimiter = {
  wordLimit: 40,
  selector: '.jdgm-carousel-wrapper .jdgm-carousel-item__review-body p'
};

(function (settings) {
  if (!settings) return;

  
  function normalizeText(text) {
    return (text || '').trim().replace(/\s+/g, ' ');
  }

  function getLimitedText(text, limit) {
    const cleanText = normalizeText(text);
    if (!cleanText) return '';

    const words = cleanText.split(' ');
    if (words.length <= limit) return cleanText;

    return words.slice(0, limit).join(' ') + '...';
  }

  function limitJudgeMeReviews() {
    const items = document.querySelectorAll(settings.selector);
   
    if (!items.length) return;

    items.forEach(function (item) {
      const liveText = normalizeText(item.textContent);

      if (!item.dataset.fullReview) {
        item.dataset.fullReview = liveText;
      }

      const finalText = getLimitedText(item.dataset.fullReview, settings.wordLimit);

      if (normalizeText(item.textContent) !== finalText) {
        item.textContent = finalText;
      }
    });
  }

  function initJudgeMeLimiter() {
    limitJudgeMeReviews();

    const observer = new MutationObserver(function () {
      limitJudgeMeReviews();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    let tries = 0;
    const timer = setInterval(function () {
      limitJudgeMeReviews();
      tries++;

      if (tries > 80) {
        clearInterval(timer);
      }
    }, 700);

    window.addEventListener('load', limitJudgeMeReviews);
    document.addEventListener('DOMContentLoaded', limitJudgeMeReviews);
  }

  initJudgeMeLimiter();
})(window.jdgmReviewLimiter);
